<template>
  <b-navbar toggleable="lg" type="dark" id="nav">
    <b-navbar-brand @click="gotoHomepage">
      <img
        alt="logo"
        class="d-inline-block align-top pointer"
        src="../assets/images/logo/logo_mini.png"
      />
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"> </b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto text-center text-black-50">
        <template v-if="!accessToken">
          <b-navbar-nav class="text-lg-end">
            <b-button
              class="btn btn-info"
              pill
              style="
                background-color: #41634a;
                width: 100% !important;
                color: white;
              "
              @click="login"
              >สำหรับหน่วยงาน
            </b-button>
          </b-navbar-nav>
        </template>
        <template v-else>
          <b-navbar-nav class="text-lg-end">
            <b-nav-item
              @click="topage('/Survey')"
              class="mx-2"
              v-if="this.user.user.group_id != '4'"
              >บันทึกการสำรวจ
            </b-nav-item>
            <b-nav-item to="/Result" class="mx-2">ผลการบันทึก</b-nav-item>
            <b-nav-item
              @click="topage('/Report')"
              class="mx-2"
              v-if="this.user.user.group_id < '4'"
              >รายงาน
            </b-nav-item>
            <b-nav-item
              class="mx-2"
              v-if="this.user.user.group_id < '4'"
              @click="gotoManagement"
              >การจัดการ
            </b-nav-item>
            <b-nav-item-dropdown right>
              <!-- Using 'button-content' slot -->
              <template #button-content>
                <b>โปรไฟล์</b>
              </template>
              <b-dropdown-item @click="communityDetail()">
                <b-icon icon="person"></b-icon
                >{{
                  this.user.user.first_name + " " + this.user.user.last_name
                }}
              </b-dropdown-item>
              <b-dropdown-item
                v-if="user.user.group_id <= 2"
                @click="communityDetail()"
              >
                <b-icon icon="house-door"></b-icon> ชุมชน
              </b-dropdown-item>
              <b-dropdown-item @click="logout"
                ><b-icon icon="box-arrow-right"></b-icon> Sign
                Out</b-dropdown-item
              >
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </template>
      </b-navbar-nav>
    </b-collapse>
    <!--      <b-col>-->
    <b-navbar-brand class="nav-logo2">
      <img
        src="../assets/images/logo/logo_community_biobank.png"
      />
    </b-navbar-brand>

    <!--      </b-col>-->
  </b-navbar>
  <!--  <b-navbar id="nav">-->
  <!--    <b-navbar-brand @click="gotoHomepage">-->
  <!--      <img-->
  <!--        alt="logo"-->
  <!--        class="d-inline-block align-top"-->
  <!--        src="../assets/images/logo/logo_mini.svg"-->
  <!--      />-->
  <!--    </b-navbar-brand>-->

  <!--  </b-navbar>-->
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "navbar",
  computed: {
    ...mapState({
      accessToken: (state) => state.AuthModule.accessToken,
      user: (state) => state.AuthModule.userData,
    }),
  },
  methods: {
    communityDetail() {
      if (this.user.user.group_id !== 4) {
        this.$router.push("/CommunityEdit");
      }
    },
    gotoManagement() {
      window.open("https://bedo-bio-admin.ksta.co/", "_blank");
    },
    topage(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    logout() {
      this.$store
        .dispatch("AuthModule/onLogOut", this.user.user.id)
        .then(() => {
          this.$router.push("/");
        });
    },
    gotoHomepage() {
      const path = `/`;
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    login() {
      const path = `/Login`;
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    goToForm() {
      const path = `/Survey`;
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
  },
};
</script>
<style lang="scss">
.navbar-dark .navbar-nav .nav-link {
  color: #333333 !important;
}
.navbar-dark .navbar-toggler {
  color: rgb(148 169 141 / 50%) !important;
  border-color: rgb(6 104 6 / 10%) !important;
  background-color: #5a7e64;
}
#nav {
  //padding: 0px;
  //margin-top: 20px;
  //margin-left: 30px;
  //margin-right: 30px;
  background-color: transparent;
  position: relative;
  //z-index: 3;

  //a {
  //  font-weight: bold;
  //  color: #2c3e50;
  //
  //  &.router-link-exact-active {
  //    color: #42b983;
  //  }
  //}
}
@media only screen and (max-width: 992px) {
  .navbar-brand.nav-logo2 {
    display: none;
  }
}
</style>
